import styled from '@emotion/styled';

export const InhaltAdditionalHeader = styled.h3({
  fontWeight: 500,
  marginBottom: 15
});
